import { useState, useMemo } from 'react';

export type DateRangePreset = '7' | '15' | '30' | '90' | 'custom';

export interface DateRange {
  startDate: Date;
  endDate: Date;
  preset: DateRangePreset;
}

export const useDateRange = () => {
  const [preset, setPreset] = useState<DateRangePreset>('30');
  const [customStartDate, setCustomStartDate] = useState<string>('');
  const [customEndDate, setCustomEndDate] = useState<string>('');

  const dateRange = useMemo<DateRange>(() => {
    const endDate = new Date();
    endDate.setHours(23, 59, 59, 999);

    let startDate: Date;

    if (preset === 'custom') {
      if (customStartDate && customEndDate) {
        startDate = new Date(customStartDate);
        startDate.setHours(0, 0, 0, 0);
        const customEnd = new Date(customEndDate);
        customEnd.setHours(23, 59, 59, 999);
        return {
          startDate,
          endDate: customEnd,
          preset: 'custom',
        };
      }
      // Fallback to 30 days if custom dates not set
      startDate = new Date();
      startDate.setDate(startDate.getDate() - 30);
      startDate.setHours(0, 0, 0, 0);
    } else {
      const days = parseInt(preset);
      startDate = new Date();
      startDate.setDate(startDate.getDate() - days);
      startDate.setHours(0, 0, 0, 0);
    }

    return {
      startDate,
      endDate,
      preset,
    };
  }, [preset, customStartDate, customEndDate]);

  const dateRangeString = useMemo(() => {
    return {
      startDate: dateRange.startDate.toISOString(),
      endDate: dateRange.endDate.toISOString(),
    };
  }, [dateRange]);

  return {
    dateRange,
    dateRangeString,
    preset,
    setPreset,
    customStartDate,
    setCustomStartDate,
    customEndDate,
    setCustomEndDate,
  };
};

